'use strict';
/**
 * To mimic enum com.vhi.group.web.transactions.TransactionStage from backend
 * Created by c_razmuss_a on 30/01/2018.
 */
//const
var transactionStage = ['INIT', 'POLICY', 'PEOPLE', 'DETAILS', 'COVER', 'ADDONS', 'PLAN', 'CHECKOUT', 'PREFERENCES', 'REVIEW', 'COMPLETED'];

function createStageObject() {
    var result = {};
    transactionStage.forEach(function (stage) {
       result[stage] = stage;
    });
    result.indexOf = function(s, i) {
        return transactionStage.indexOf(s, i);
    };
    return result;
}

module.exports = createStageObject();



//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/transactionStage.js
// module id = 2NfQ
// module chunks = 0 1 2 3 5 6